"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  WirelessPaymentCreditCard: ['wireless-payment-credit-card', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,23.25H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h10.5a1.5,1.5,0,0,1,1.5,1.5v9', 'M0.75 19.5L6.75 19.5', 'M9.750 14.250 L23.250 14.250 L23.250 23.250 L9.750 23.250 Z', 'M9.75 17.25L23.25 17.25', 'M12.75 20.25L15 20.25']],
  WirelessPaymentSmartphone: ['wireless-payment-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,13.5H.75l.842-5.164A.986.986,0,0,1,2.557,7.5H7.193a.986.986,0,0,1,.965.836Z', 'M10.5,22.984V15A1.5,1.5,0,0,0,9,13.5', 'M4.109 10.496L6.065 10.496', 'M5.25 7.504L5.25 5.254', 'M2.250 2.246 L8.250 2.246 L8.250 5.246 L2.250 5.246 Z', 'M22.5,2.138a6.222,6.222,0,0,0-7.826,0', 'M16.3,4.5a3.633,3.633,0,0,1,4.566,0', 'M16.329,16.09a2.225,2.225,0,0,0,1.859.875c1.138,0,2.062-.692,2.062-1.547s-.924-1.546-2.062-1.546-2.063-.693-2.063-1.548.924-1.547,2.063-1.547a2.224,2.224,0,0,1,1.858.875', 'M18.188 16.965L18.188 17.996', 'M18.188 9.746L18.188 10.777', 'M21.3,23.246H15.45a1.959,1.959,0,0,1-1.95-1.969V9.465A1.96,1.96,0,0,1,15.45,7.5H21.3a1.96,1.96,0,0,1,1.95,1.969V21.277A1.959,1.959,0,0,1,21.3,23.246Z', 'M13.5 20.246L23.25 20.246']],
  SelfPayment: ['self-payment', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.878,19.259a.456.456,0,0,1,.122.308v3.2a.5.5,0,0,1-.525.482H3.525A.5.5,0,0,1,3,22.768v-3.2a.456.456,0,0,1,.122-.308l2.346-2.586a.546.546,0,0,1,.4-.173H18.129a.546.546,0,0,1,.4.173Z', 'M21 19.5L3 19.5', 'M12 13.5L12 16.5', 'M14.829,9.344a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M16.687 10.219L16.687 11.25', 'M16.687 3L16.687 4.031', 'M6 0.75L6 13.5', 'M10.5 13.5L10.5 0.75', 'M1.5 5.25L10.5 5.25', 'M1.5 9.75L10.5 9.75', 'M1.500 0.750 L22.500 0.750 L22.500 13.500 L1.500 13.500 Z']],
  ContactlessPayment: ['contactless-payment', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,10.826,19.355,7.8a3.565,3.565,0,0,0-4.712.293l-.305.306', 'M.75,6.152a5.4,5.4,0,0,1,5.4-5.4', 'M3.509,6.241A3.241,3.241,0,0,1,6.75,3', 'M4.221,9.33l-.733.733a1.079,1.079,0,0,0,0,1.527l9.275,9.276a1.08,1.08,0,0,0,1.528,0l1.119-1.135', 'M18.2,17l1.589-1.629a1.079,1.079,0,0,0,0-1.527L10.51,4.568a1.08,1.08,0,0,0-1.528,0l-.472.473', 'M15.57 15.265L18.387 12.448', 'M11.367 19.469L13.318 17.517', 'M23.25,23.25l-5.143-1.714a5.978,5.978,0,0,1-2.336-1.444l-2.137-2.137a1.679,1.679,0,0,1,2.119-2.584l3.716,2.477', 'M9.83,13.382a2.222,2.222,0,0,0,1.95-.643,1.861,1.861,0,0,0,.432-2.542,1.86,1.86,0,0,0-2.56.3,1.863,1.863,0,0,1-2.562.3,1.863,1.863,0,0,1,.432-2.542A2.222,2.222,0,0,1,9.472,7.6', 'M11.78 12.739L12.489 13.486', 'M6.813 7.5L7.522 8.248']],
  SmartphonePayDollar: ['smartphone-pay-dollar', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.767,7.844a2.221,2.221,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.923-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M14.625 8.719L14.625 9.75', 'M14.625 1.5L14.625 2.531', 'M12.75,15v6.75a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5V5.25a1.5,1.5,0,0,1,1.5-1.5', 'M0.75 19.5L12.75 19.5', 'M18,.75h3.75a1.5,1.5,0,0,1,1.5,1.5V10.5a1.5,1.5,0,0,1-1.5,1.5h-15a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,6.75.75h4.5']],
  SmartphonePaymentTouch: ['smartphone-payment-touch', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,18.75V13.5c0-2-3.8-4.139-5.25-5.25', 'M19.93,14.794,16.282,11.87a1.3,1.3,0,0,0-1.843,1.843L17.973,17.7v2.5c0,1.181,1.687,3.045,1.687,3.045', 'M8.733.75H16.5A1.5,1.5,0,0,1,18,2.25v11', 'M15,21.75H7.5A1.5,1.5,0,0,1,6,20.25v-7.5', 'M6 18L12 18', 'M10.329,9.344a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.546-2.063-1.546-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M12.187 10.219L12.187 11.25', 'M12.187 3L12.187 4.031', 'M3.75 3.75L3.75 6.75', 'M2.2,1.182A2.976,2.976,0,0,1,3.75.75h0a3.009,3.009,0,0,1,3,3v3c0,.076,0,.151-.008.225', 'M5.383,9.263A2.972,2.972,0,0,1,3.75,9.75h0a3.009,3.009,0,0,1-3-3v-3']],
  CreditCardSmartphoneExchange: ['credit-card-smartphone-exchange', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 11.250 L23.250 11.250 L23.250 23.250 L15.750 23.250 Z', 'M15.75 20.25L23.25 20.25', 'M3.75,15.75a6,6,0,0,0,6,6H12', 'M23.25,8.25a6,6,0,0,0-6-6h-1.5', 'M17.25 0.75L15.75 2.25 17.25 3.75', 'M10.5 23.25L12 21.75 10.5 20.25', 'M0.750 0.750 L12.750 0.750 L12.750 9.750 L0.750 9.750 Z', 'M0.75 3.75L12.75 3.75', 'M9.75 6.75L6.75 6.75']],
  WirelessPaymentSmartphone1: ['wireless-payment-smartphone-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.125 20.25L1.875 20.25', 'M1.875,12.75h3.75a1.373,1.373,0,0,0,.879-.461L10.554,8.3l3.829.766a.963.963,0,0,1,.747,1.179l-.08.318a.963.963,0,0,1-.8.721l-1.876.272a.842.842,0,0,0-.75.955v2.557a1.4,1.4,0,0,1-.44.753L9.107,17.464', 'M22.125,18.5a.983.983,0,0,1-.964,1H19.714c-.7,0-1.141-.051-1.446-1a59.368,59.368,0,0,1-.964-7c0-.5.482-1,1.446-1h2.411a.983.983,0,0,1,.964,1Z', 'M20.625,19.5v2.25a1.5,1.5,0,0,1-1.5,1.5h-7.5a1.5,1.5,0,0,1-1.5-1.5v-1.5', 'M10.125,8.725V6a1.5,1.5,0,0,1,1.5-1.5h7.5a1.5,1.5,0,0,1,1.5,1.5v4.5', 'M6.032.75A6.262,6.262,0,0,0,2.758,6.883', 'M7.606,2.8A4.334,4.334,0,0,0,5.339,7.048']],
  SmartphonePayDollar1: ['smartphone-pay-dollar-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,14.25v7.5a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-18a1.5,1.5,0,0,1,1.5-1.5H9', 'M0.75 18.75L12.75 18.75', 'M18.75,3.75H16.717a1.341,1.341,0,0,0-.5,2.587l2.063.826a1.342,1.342,0,0,1-.5,2.587H15.75', 'M17.25 3.75L17.25 3', 'M17.25 10.5L17.25 9.75', 'M11.250 6.750 A6.000 6.000 0 1 0 23.250 6.750 A6.000 6.000 0 1 0 11.250 6.750 Z']],
  SelfPaymentTouch: ['self-payment-touch', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,23.25H1.275a.5.5,0,0,1-.525-.482v-3.2a.456.456,0,0,1,.122-.308l2.346-2.586a.546.546,0,0,1,.4-.173H10.5', 'M6.75 19.5L0.75 19.5', 'M10.5 13.5L10.5 16.5', 'M5.829,9.344a2.224,2.224,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547S8.826,7.126,7.687,7.126,5.625,6.433,5.625,5.578s.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875', 'M7.687 10.219L7.687 11.25', 'M7.687 3L7.687 4.031', 'M23.136,23.25l.1-1.122a3,3,0,0,0-2.337-3.2l-3.651-.812V12.375a2.075,2.075,0,0,0-1.949-1.86,1.884,1.884,0,0,0-1.8,1.86v9.2l-1.477-1.108a1.533,1.533,0,0,0-2.146,2.146l.475.632', 'M10.5,13.5H2.25A1.5,1.5,0,0,1,.75,12V2.25A1.5,1.5,0,0,1,2.25.75h18a1.5,1.5,0,0,1,1.5,1.5V12a1.5,1.5,0,0,1-1.5,1.5']],
  SmartphonePayDollar2: ['smartphone-pay-dollar-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.75,23.25H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h10.5a1.5,1.5,0,0,1,1.5,1.5v6', 'M0.75 18.75L8.25 18.75', 'M18.75,14.25H16.717a1.342,1.342,0,0,0-.5,2.587l2.064.826a1.342,1.342,0,0,1-.5,2.587H15.75', 'M17.25 14.25L17.25 13.5', 'M17.25 21L17.25 20.25', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z']]
};
exports["default"] = _default;